





















import Vue from "vue";
import LoginForm from '../components/LoginForm.vue';
import Navbar from '../components/Navbar.vue';


export default Vue.extend({
  name: "login",
  components: {
    LoginForm,
    Navbar
  },
  data: () => ({
    height: "700", 
  }),
  methods: {},
  mounted() {
    if (this.$parent.$el.clientHeight) {
      this.height = this.$parent.$el.clientHeight * 0.9;
    }
  }
});
